import { createContext, useContext } from "react";

export const MainBannerContext = createContext<Boolean>(false);

export const useMainBannerContext = () => useContext(MainBannerContext);
